import React, { useState, useEffect } from "react";
import PDFMerger from 'pdf-merger-js/browser';
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch } from "react-redux";
import { setError, setSuccess, setWarning } from "../../reducers/appSlice";
import VisorPdf from "../../components/Visorpdf";
import { Typography } from "@mui/material";
import { useHistory } from "react-router-dom";

// iconos
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

// Dialogos de botones de acción
import ConfirmDialog from "../../components/ConfirmDialog";

//servicios
import api from "../../service/api";
import Modal from "../../components/Modal";

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var len = binaryString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

const ITEM_HEIGHT = 148;

export default function LongMenu(props) {
  // seteos
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [documento, setDocumento] = useState("");
  const [openDocumento, setOpenDocumento] = useState(false);
  const [tipo] = useState(props.tipo);
  const [soporte] = useState(props.soporte);
  const [permiso] = useState(props.permiso);
  const [permisos] = useState(props.permisos);
  const [generandoDocumento, setGenerandoDocumento] = useState(false);
  const [generandoZip, setGenerandoZip] = useState(false);
  const [tienePermisoAgregarAdjunto, setTienePermisoAgregarAdjunto] = useState("N");
  const history = useHistory();

  useEffect(() => {
    async function buscarPermisoAgregarAdjuntos() {
      try {
        let filtro = {
          tra_id: props.idTramite,
        };
        let res = await api.buscarPermisoAgregarAdjuntos(filtro);
        setTienePermisoAgregarAdjunto(res.data[0].tiene_permiso);
      } catch (e) {
        dispatch(
          setError(
            "Error al consultar los permisos"
          )
        );
      }
    }
    buscarPermisoAgregarAdjuntos();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.idTramite]);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // handles
  const handleCloseDocument = () => {
    setOpenDocumento(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // funciones
  const verCaratula = async (tramiteId) => {
    try {
      let base64 = await api.obtenerCaratula({ tramiteId: tramiteId });
      setDocumento(base64.data);
      setOpenDocumento(true);
    } catch (e) {
      dispatch(setError("Error al obtener la carátula"));
    }
  };

  const verVolante = async (tramiteId) => {
    try {
      let base64 = await api.obtenerVolante({ tramiteId: tramiteId });
      setDocumento(base64.data);
      setOpenDocumento(true);
    } catch (e) {
      dispatch(setError("Error al obtener el volante"));
    }
  };

  const verFicha = async (tramiteId) => {
    try {
      let base64 = await api.obtenerFicha({ tramiteId: tramiteId });
      setDocumento(base64.data);
      setOpenDocumento(true);
    } catch (e) {
      dispatch(setError("Error al obtener la ficha"));
    }
  };

  const generarTramite = () => {
    setGenerandoDocumento(true);
    api
      .generarTramite({ tramiteId: props.idTramite })
      .then(async (res) => {
        if (res.data.archivos.length > 0) {
          const merger = new PDFMerger();

          for (let i = 0; i < res.data.archivos.length; i++) {
            await merger.add(base64ToArrayBuffer(res.data.archivos[i]));
          }

          const blob = await merger.saveAsBlob();
          
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            setDocumento(reader.result.replace("data:application/pdf;base64,", ""));
            setOpenDocumento(true);
          }
        } else {
          dispatch(setWarning("No posee adjuntos"));
        }
      })
      .catch((e) => dispatch(setError(e.response.data.error)))
      .finally(() => {
        setGenerandoDocumento(false);
        handleClose();
      });
  };

  const descargarZip = () => {
    setGenerandoZip(true);
    api
      .generarZip({ tramiteId: props.idTramite })
      .then((res) => {
        if (res.data.zip !== "") {
          let nombreArchivo = "adjuntos.zip";
          const url = "data:text/plain;base64," + res.data.zip;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombreArchivo);
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          dispatch(setWarning("No posee adjuntos"))
        }
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      })
      .finally(() => {
        setGenerandoZip(false);
        handleClose();
      });
  };
  const accionConfirmarEliminar = () => {

    api
      .eliminarTramite({ tramiteId: props.idTramite })
      .then((res) => {

        dispatch(setSuccess("Se eliminó el trámite con éxito"));
        setTimeout(() => history.push("/bandeja_entrada/"), 1500);

      })
      .catch((e) => {
        console.log(e.response.data.detalle);
        dispatch(setError(e.response.data.error));
        // setTimeout(() => history.push("/bandeja_entrada/"), 1500);
      });

  }
  return (
    <div>
      <Modal open={openDocumento} handleClose={handleCloseDocument} closeButton>
        <VisorPdf url={"data:application/octet-stream;base64," + documento} />
      </Modal>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "35ch",
          },
        }}
      >
        <MenuItem
          key={1}
          onClick={() => {
            verCaratula(props.idTramite);
            handleClose();
          }}
          disabled={soporte === "DIGITAL" || permiso === false}
        >
          <IconButton title="Carátula" size="small">
            <PictureAsPdfOutlinedIcon fontSize="small" />
          </IconButton>
          <Typography variant="cuerpo">Carátula</Typography>
        </MenuItem>
        <MenuItem
          key={2}
          onClick={() => {
            verFicha(props.idTramite);
            handleClose();
          }}
        >
          <IconButton title="Ficha" size="small">
            <PictureAsPdfOutlinedIcon fontSize="small" />
          </IconButton>
          <Typography variant="cuerpo">Ficha</Typography>
        </MenuItem>
        <MenuItem
          key={3}
          onClick={() => {
            verVolante(props.idTramite);
            handleClose();
          }}
        >
          <IconButton title="Volante" size="small">
            <PictureAsPdfOutlinedIcon fontSize="small" />
          </IconButton>
          <Typography variant="cuerpo">Volante</Typography>
        </MenuItem>
        {tipo ? (
          <MenuItem
            key={4}
            onClick={generarTramite}
            disabled={soporte === "PAPEL" || generandoDocumento || permisos === 'N' || tienePermisoAgregarAdjunto !== "S"}
          >
            <IconButton title="Ver expediente completo" size="small">
              <PictureAsPdfOutlinedIcon fontSize="small" />
            </IconButton>
            <Typography variant="cuerpo">
              Ver expediente completo
            </Typography>
          </MenuItem>
        ) : (
            <MenuItem
              key={4}
              onClick={generarTramite}
              disabled={soporte === "PAPEL" || generandoDocumento || permisos === 'N' || tienePermisoAgregarAdjunto !== "S"}
            >
              <IconButton
                title="Ver trámite interno completo"
                size="small"
              >
                <PictureAsPdfOutlinedIcon fontSize="small" />
              </IconButton>
              <Typography variant="cuerpo">
                Ver trámite interno completo
            </Typography>
            </MenuItem>
          )}
        <MenuItem
          key={5}
          onClick={descargarZip}
          disabled={soporte === "PAPEL" || generandoZip || permisos === 'N' || tienePermisoAgregarAdjunto !== "S"}
        >
          <IconButton title="Descargar ZIP" size="small">
            <FileDownloadOutlinedIcon fontSize="small" />
          </IconButton>
          <Typography variant="cuerpo">Descargar ZIP</Typography>
        </MenuItem>
        <MenuItem
          key={6}
          disabled={props.soporte === "DIGITAL"}
        >
          {tipo ? (
            <ConfirmDialog
              text="Vas a eliminar el expediente"
              subText="¿Querés continuar?"
              icon={<DeleteOutlineOutlinedIcon text="Eliminar" fontSize="small" />}
              iconTitle="Eliminar expediente"
              handleConfirm={accionConfirmarEliminar}
              data={props.idTramite}
            />
          ) : (
              <ConfirmDialog
                text="Vas a eliminar el trámite interno"
                subText="¿Querés continuar?"
                icon={<DeleteSweepIcon fontSize="small" />}
                iconTitle="Eliminar trámite interno"
                title="Eliminar"
                handleConfirm={accionConfirmarEliminar}
                data={props.idTramite}
              />
            )}
        </MenuItem>
      </Menu>
    </div>
  );
}
